module.exports = __webpack_public_path__ + "img/partner15.7f4a37c2.jpg";